import React from 'react';
import Icon, { IconType } from '../../icons/Icon';
import { Tooltip } from '../Tooltip';

// Currently we really only need top (for most like TextInput, Dropdown) and right (for Checkbox)
export enum LabelPlace {
  top = 'top',
  // bottom = 'bottom',
  // left = 'left',
  right = 'right',
}

const places: Record<LabelPlace, string> = {
  top: 'flex-col',
  // bottom: 'flex-col-reverse',
  // left: 'flex-row',
  right: 'flex-row-reverse items-center',
};

interface LabelProps {
  label: string;
  children: React.ReactNode;
  mandatory?: boolean;
  place?: LabelPlace;
  inputId?: string;
  gap?: string;
  tooltip?: React.ReactNode;
  className?: string;
}

export default function Label({
  label,
  children,
  mandatory = false,
  place = LabelPlace.top,
  inputId,
  gap = 'gap-1',
  tooltip,
  className = '',
}: LabelProps) {
  return (
    <div className={`${places[place]} flex ${gap} ${className}`}>
      <label htmlFor={inputId} className='unset w-fit'>
        <span className='flex items-center'>
          <p className='font-regular line-clamp-1 overflow-ellipsis text-sm text-gray-900'>{label}</p>
          {mandatory && <p className='font-regular pl-[2px] text-sm text-error-500'>*</p>}
          {tooltip ? (
            <Tooltip content={tooltip}>
              <Icon type={IconType.infoCircle} size={'h-4 w-4'} stroke={'stroke-gray-900'} className={'ml-1'} />
            </Tooltip>
          ) : null}
        </span>
      </label>
      {children}
    </div>
  );
}
